// The broker's theme choice (BRK-S245). They pick Day, Night or System from the
// user menu; the page renders one of two schemes, light or dark. System defers
// to the OS's `prefers-color-scheme`. index.html's pre-paint script repeats
// resolveThemeMode in plain JS so the first paint is already right, and
// test/lib/themeInit.test.ts holds the two to the same answers.

export const THEME_CHOICES = ["day", "night", "system"] as const;

export type ThemeChoice = (typeof THEME_CHOICES)[number];

/** The scheme the page renders, as `data-theme` on <html>. */
export type ThemeMode = "light" | "dark";

export function isThemeChoice(value: unknown): value is ThemeChoice {
  return (
    typeof value === "string" &&
    (THEME_CHOICES as readonly string[]).includes(value)
  );
}

export function resolveThemeMode(
  choice: ThemeChoice,
  systemPrefersDark: boolean,
): ThemeMode {
  if (choice === "day") return "light";
  if (choice === "night") return "dark";
  return systemPrefersDark ? "dark" : "light";
}
